(function ($) {
    ("use strict");
    // Page loading
    /*$(window).on("load", function () {
        $("#preloader-active").fadeOut("slow");
    });*/
    /*-----------------
        Menu Stick
    -----------------*/
    var header = $(".sticky-bar");
    var win = $(window);
    win.on("scroll", function () {
        var scroll = win.scrollTop();
        if (scroll < 200) {
            header.removeClass("stick");
            $(".header-style-2 .categories-dropdown-active-large").removeClass("open");
            $(".header-style-2 .categories-button-active").removeClass("open");
        } else {
            header.addClass("stick");
        }
    });
    /*------ ScrollUp -------- */
    $.scrollUp({
        scrollText: '<i class="fi-rr-arrow-small-up"></i>',
        easingType: "linear",
        scrollSpeed: 900,
        animation: "fade"
    });
    /*------ Wow Active ----*/
    new WOW().init();
    //sidebar sticky
    if ($(".sticky-sidebar").length) {
        $(".sticky-sidebar").theiaStickySidebar();
    }
    /*----------------------------
        Category toggle function
    ------------------------------*/
    if ($(".categories-button-active").length) {
        var searchToggle = $(".categories-button-active");
        searchToggle.on("click", function (e) {
            e.preventDefault();
            if ($(this).hasClass("open")) {
                $(this).removeClass("open");
                $(this).siblings(".categories-dropdown-active-large").removeClass("open");
            } else {
                $(this).addClass("open");
                $(this).siblings(".categories-dropdown-active-large").addClass("open");
            }
        });
    }
    /*---------------------
        Select active
    --------------------- */
    /*
    if ($(".select-active").length) {
        $(".select-active").select2();
    }
    */
    /*---- CounterUp ----*/
    if ($(".count").length) {
        $(".count").counterUp({
            delay: 10,
            time: 2000
        });
    }
    // Isotope active
    if ($(".grid").length) {
        $(".grid").imagesLoaded(function () {
            // init Isotope
            var $grid = $(".grid").isotope({
                itemSelector: ".grid-item",
                percentPosition: true,
                layoutMode: "masonry",
                masonry: {
                    // use outer width of grid-sizer for columnWidth
                    columnWidth: ".grid-item"
                }
            });
        });
    }
    /*====== SidebarSearch ======*/
    /*
    function sidebarSearch() {
        var searchTrigger = $(".search-active"),
            endTriggersearch = $(".search-close"),
            container = $(".main-search-active");
        searchTrigger.on("click", function (e) {
            e.preventDefault();
            container.addClass("search-visible");
        });
        endTriggersearch.on("click", function () {
            container.removeClass("search-visible");
        });
    }
    sidebarSearch();
    */
   
    /*====== Sidebar menu Active ======*/
    function mobileHeaderActive() {
        var navbarTrigger = $(".burger-icon"),
            endTrigger = $(".mobile-menu-close"),
            container = $(".mobile-header-active"),
            wrapper4 = $("body");
        wrapper4.prepend('<div class="body-overlay-1"></div>');
        navbarTrigger.on("click", function (e) {
            navbarTrigger.toggleClass("burger-close");
            e.preventDefault();
            container.toggleClass("sidebar-visible");
            wrapper4.toggleClass("mobile-menu-active");
        });
        endTrigger.on("click", function () {
            container.removeClass("sidebar-visible");
            wrapper4.removeClass("mobile-menu-active");
        });
        $(".body-overlay-1").on("click", function () {
            container.removeClass("sidebar-visible");
            wrapper4.removeClass("mobile-menu-active");
            navbarTrigger.removeClass("burger-close");
        });
    }
    mobileHeaderActive();
    /*---------------------
        Mobile menu active
    ------------------------ */
    var $offCanvasNav = $(".mobile-menu"),
        $offCanvasNavSubMenu = $offCanvasNav.find(".sub-menu");
    /*Add Toggle Button With Off Canvas Sub Menu*/
    $offCanvasNavSubMenu.parent().prepend('<span class="menu-expand"><i class="fi-rr-angle-small-down"></i></span>');
    /*Close Off Canvas Sub Menu*/
    $offCanvasNavSubMenu.slideUp();
    /*Category Sub Menu Toggle*/
    $offCanvasNav.on("click", "li a, li .menu-expand", function (e) {
        var $this = $(this);
        if (
            $this
                .parent()
                .attr("class")
                .match(/\b(menu-item-has-children|has-children|has-sub-menu)\b/) &&
            ($this.attr("href") === "#" || $this.hasClass("menu-expand"))
        ) {
            e.preventDefault();
            if ($this.siblings("ul:visible").length) {
                $this.parent("li").removeClass("active");
                $this.siblings("ul").slideUp();
            } else {
                $this.parent("li").addClass("active");
                $this.closest("li").siblings("li").removeClass("active").find("li").removeClass("active");
                $this.closest("li").siblings("li").find("ul:visible").slideUp();
                $this.siblings("ul").slideDown();
            }
        }
    });
    /*--- language currency active ----*/
    $(".mobile-language-active").on("click", function (e) {
        e.preventDefault();
        $(".lang-dropdown-active").slideToggle(900);
    });
    /*--- categories-button-active-2 ----*/
    $(".categories-button-active-2").on("click", function (e) {
        e.preventDefault();
        $(".categori-dropdown-active-small").slideToggle(900);
    });
    /*--- Mobile demo active ----*/
    var demo = $(".tm-demo-options-wrapper");
    $(".view-demo-btn-active").on("click", function (e) {
        e.preventDefault();
        demo.toggleClass("demo-open");
    });
    /*-----More Menu Open----*/
    $(".more_slide_open").slideUp();
    $(".more_categories").on("click", function () {
        $(this).toggleClass("show");
        $(".more_slide_open").slideToggle();
    });
    /* --- SwiperJS --- */
    $(".swiper-group-6").each(function () {
        var swiper_6_items = new Swiper(this, {
            spaceBetween: 30,
            slidesPerView: 6,
            spaceBetween: 30,
            slidesPerGroup: 2,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            autoplay: {
                delay: 10000
            },
            breakpoints: {
                1199: {
                    slidesPerView: 6
                },
                800: {
                    slidesPerView: 4
                },
                400: {
                    slidesPerView: 2.5,
                    loop: false
                },
                350: {
                    slidesPerView: 2.5,
                    slidesPerGroup: 1,
                    spaceBetween: 15,
                    loop: false
                }
            }
        });
    });
    $(".swiper-group-3").each(function () {
        var swiper_3_items = new Swiper(this, {
            spaceBetween: 30,
            slidesPerView: 3,
            spaceBetween: 30,
            slidesPerGroup: 1,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            pagination: {
                el: ".swiper-pagination",
                type: "custom",
                renderCustom: function (swiper, current, total) {
                    var customPaginationHtml = "";
                    for (var i = 0; i < total; i++) {
                        //Determine which pager should be activated at this time
                        if (i == current - 1) {
                            customPaginationHtml += '<span class="swiper-pagination-customs swiper-pagination-customs-active"></span>';
                        } else {
                            customPaginationHtml += '<span class="swiper-pagination-customs"></span>';
                        }
                    }
                    return customPaginationHtml;
                }
            },
            autoplay: {
                delay: 10000
            },
            breakpoints: {
                1199: {
                    slidesPerView: 3
                },
                800: {
                    slidesPerView: 2
                },
                400: {
                    slidesPerView: 1
                },
                350: {
                    slidesPerView: 1
                }
            }
        });
    });
    $(".swiper-group-2").each(function () {
        var swiper_2_items = new Swiper(this, {
            spaceBetween: 30,
            slidesPerView: 2,
            spaceBetween: 30,
            slidesPerGroup: 1,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            pagination: {
                el: ".swiper-pagination",
                type: "custom",
                renderCustom: function (swiper, current, total) {
                    var customPaginationHtml = "";
                    for (var i = 0; i < total; i++) {
                        //Determine which pager should be activated at this time
                        if (i == current - 1) {
                            customPaginationHtml += '<span class="swiper-pagination-customs swiper-pagination-customs-active"></span>';
                        } else {
                            customPaginationHtml += '<span class="swiper-pagination-customs"></span>';
                        }
                    }
                    return customPaginationHtml;
                }
            },
            autoplay: {
                delay: 10000
            },
            breakpoints: {
                1199: {
                    slidesPerView: 2
                },
                800: {
                    slidesPerView: 1
                },
                600: {
                    slidesPerView: 1
                },
                400: {
                    slidesPerView: 1
                },
                350: {
                    slidesPerView: 1
                }
            }
        });
    });
    // Swiper para top offers en mobile (1.5 tarjetas)
    $(".swiper-top-offers").each(function () {
        var $container = $(this);
        new Swiper(this, {
            slidesPerView: 1.5,
            spaceBetween: 16,
            loop: false,
            navigation: {
                nextEl: $container.find('.swiper-button-next')[0],
                prevEl: $container.find('.swiper-button-prev')[0]
            },
            // Puedes agregar breakpoints si quieres ajustar en tablets, etc.
            breakpoints: {
                600: {
                    slidesPerView: 1.5,
                    spaceBetween: 16
                },
                400: {
                    slidesPerView: 1.3,
                    spaceBetween: 8
                },
                200: {
                    slidesPerView: 1.3,
                    spaceBetween: 8
                }
            }
        });
    });

    // Swiper para áreas más buscadas en mobile (1.3 tarjetas)
    $(".swiper-top-areas").each(function () {
        var $container = $(this);
        new Swiper(this, {
            slidesPerView: 1.3,
            spaceBetween: 16,
            loop: false,
            navigation: {
                nextEl: $container.find('.swiper-button-next')[0],
                prevEl: $container.find('.swiper-button-prev')[0]
            },
            breakpoints: {
                480: {
                    slidesPerView: 2,
                    spaceBetween: 16
                },
                768: {
                    slidesPerView: 2.5,
                    spaceBetween: 20
                }
            }
        });
    });


    /*====== Ajustar alturas del carrusel de ofertas ======*/
    function adjustSwiperSlideHeights() {
        // Solo ejecutar en móvil (cuando el carrusel está visible)
        if ($(window).width() <= 991) {
            $(".swiper-top-offers").each(function () {
                var $container = $(this);
                var $slides = $container.find('.swiper-slide');
                var $cards = $container.find('.card-grid-2');
                
                // Calcular altura máxima SIN resetear primero
                var maxHeight = 0;
                $cards.each(function() {
                    var $card = $(this);
                    if ($card.is(':visible')) {
                        var cardHeight = $card.outerHeight();
                        if (cardHeight > maxHeight) {
                            maxHeight = cardHeight;
                        }
                    }
                });
                
                // Solo aplicar si hay una altura válida Y es diferente a la actual
                if (maxHeight > 0) {
                    var currentMinHeight = parseInt($cards.first().css('min-height')) || 0;
                    
                    // Solo cambiar si la nueva altura es diferente
                    if (Math.abs(maxHeight - currentMinHeight) > 5) { // 5px de tolerancia
                        $cards.css('min-height', maxHeight + 'px');
                        $slides.css('height', maxHeight + 'px');
                    }
                }
            });

            // 🔹 Igualar altura en swiper-top-areas
            $(".swiper-top-areas").each(function () {
                var $container = $(this);
                var $slides = $container.find('.swiper-slide');
                var $cards = $container.find('.card-grid');

                var maxHeight = 0;
                $cards.each(function () {
                    var $card = $(this);
                    if ($card.is(':visible')) {
                        var cardHeight = $card.outerHeight();
                        if (cardHeight > maxHeight) {
                            maxHeight = cardHeight;
                        }
                    }
                });

                if (maxHeight > 0) {
                    var currentMinHeight = parseInt($cards.first().css('min-height')) || 0;
                    if (Math.abs(maxHeight - currentMinHeight) > 5) {
                        $cards.css('min-height', maxHeight + 'px');
                        $slides.css('height', maxHeight + 'px');
                    }
                }
            });
        }
    }

    // Variable global para debouncing
    let adjustHeightsTimeout;

    function debouncedAdjustSwiperSlideHeights() {
        // Cancelar ejecución anterior si existe
        if (adjustHeightsTimeout) {
            clearTimeout(adjustHeightsTimeout);
        }
        
        // Ejecutar solo después de 200ms sin nuevas llamadas
        adjustHeightsTimeout = setTimeout(function() {
            adjustSwiperSlideHeights();
        }, 200);
    }

    // Ejecutar cuando el DOM esté listo
    $(document).ready(function() {
        setTimeout(function() {
            debouncedAdjustSwiperSlideHeights();
        }, 1000);
    });

    // Ejecutar cuando todas las imágenes estén cargadas
    $(window).on('load', function() {
        debouncedAdjustSwiperSlideHeights();
    });

    // Ejecutar en resize
    $(window).on('resize', function() {
        debouncedAdjustSwiperSlideHeights();
    });

    // Observar cambios en el DOM para tarjetas dinámicas
    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    var $target = $(mutation.target);
                    if ($target.hasClass('swiper-top-offers') || $target.parents('.swiper-top-offers').length) {
                        debouncedAdjustSwiperSlideHeights();
                    }
                }
            });
        });
        
        // Observar cambios en el contenedor del carrusel
        var targetNode = document.querySelector('.swiper-top-offers');
        if (targetNode) {
            observer.observe(targetNode, {
                childList: true,
                subtree: true
            });
        }
    }

    //Dropdown selected item
    $(".dropdown-menu li a").on("click", function (e) {
        e.preventDefault();
        $(this)
            .parents(".dropdown")
            .find(".btn span")
            .html($(this).text() + ' <span class="caret"></span>');
        $(this).parents(".dropdown").find(".btn").val($(this).data("value"));
    });
    $(".list-tags-job .remove-tags-job").on("click", function (e) {
        e.preventDefault();
        $(this).closest(".job-tag").remove();
    });
    // Video popup
    if ($(".popup-youtube").length) {
        $(".popup-youtube").magnificPopup({
            type: "iframe",
            mainClass: "mfp-fade",
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
    }
    
    /*====== Mobile Filter Button ======*/
    function mobileFilterActive() {
        var $mobileFilterBtn = $("#mobile-filter-btn");
        var $sidebar = $("#sidebar-filters");
        var $overlay = $("#filter-overlay");
        var $body = $("body");
        var $badge = $("#filter-badge");
        
        if ($mobileFilterBtn.length && $sidebar.length && $overlay.length) {
            // Contar filtros activos
            function countActiveFilters() {
                var count = 0;
                var urlParams = new URLSearchParams(window.location.search);
                
                // Filtros de texto
                if (urlParams.get('title') && urlParams.get('title').trim() !== '') {
                    count++;
                }
                
                // Filtros de arrays (checkboxes y selects múltiples)
                var arrayFilters = ['type', 'country', 'place_job', 'category_area', 'client', 'benefits'];
                arrayFilters.forEach(function(filterName) {
                    var values = urlParams.getAll(filterName + '[]');
                    if (values.length > 0) {
                        count += values.length;
                    }
                });
                
                // Filtro de checkbox único
                if (urlParams.get('is_international') === 'true') {
                    count++;
                }
                
                // Filtro tech
                if (urlParams.get('tech') === 'true') {
                    count++;
                }
                
                return count;
            }
            
            // Actualizar badge
            function updateFilterBadge() {
                var count = countActiveFilters();
                
                if (count > 0) {
                    $badge.text(count).show();
                } else {
                    $badge.hide();
                }
            }
            
            // Mostrar el botón solo en móvil
            function checkScreenSize() {
                if ($(window).width() <= 991) {
                    $mobileFilterBtn.css('display', 'flex');
                    updateFilterBadge(); // Actualizar badge cuando se muestre
                } else {
                    $mobileFilterBtn.css('display', 'none');
                    // NO llamar a closeMobileFilters() aquí para evitar el salto
                }
            }
            
            // Abrir filtros móviles con transición suave
            function openMobileFilters() {
                // Solo ejecutar en móvil
                if ($(window).width() > 991) return;
                
                // Configurar overlay
                $overlay.css({
                    'opacity': '0',
                    'transition': 'opacity 0.3s ease-in-out'
                }).show();
                
                // Configurar sidebar inicialmente fuera de pantalla
                $sidebar.css({
                    'position': 'fixed',
                    'top': '0',
                    'right': '0',
                    'width': '90%',
                    'max-width': '400px',
                    'height': '100vh',
                    'background': 'white',
                    'z-index': '1050',
                    'overflow': 'auto',
                    'padding': '20px',
                    'box-shadow': '-2px 0 10px rgba(0,0,0,0.1)',
                    'transform': 'translateX(100%)', // Fuera de pantalla
                    'transition': 'none' // Sin transición inicialmente
                });
                
                // Forzar repaint del navegador
                $sidebar[0].offsetHeight;
                
                // Ahora aplicar la transición y animar
                $sidebar.css({
                    'transition': 'transform 0.3s ease-in-out',
                    'transform': 'translateX(0)' // Deslizar hacia adentro
                });
                
                // Animar overlay
                $overlay.css('opacity', '1');
                
                $body.css('overflow', 'hidden');
                
                // Agregar botón de cerrar si no existe
                if (!$("#close-mobile-filter").length) {
                    var $closeBtn = $('<button id="close-mobile-filter"><i class="fas fa-times"></i></button>');
                    $closeBtn.css({
                        'position': 'absolute',
                        'top': '10px',
                        'right': '10px',
                        'background': '#7D42F4',
                        'color': 'white',
                        'border': 'none',
                        'width': '40px',
                        'height': '40px',
                        'border-radius': '50%',
                        'cursor': 'pointer',
                        'z-index': '1060',
                        'opacity': '0',
                        'transition': 'opacity 0.3s ease-in-out'
                    });
                    $closeBtn.on('click', closeMobileFilters);
                    $sidebar.append($closeBtn);
                    
                    // Fade-in del botón de cerrar
                    setTimeout(function() {
                        $closeBtn.css('opacity', '1');
                    }, 150);
                }
            }
            
            // Cerrar filtros móviles con transición suave
            function closeMobileFilters() {
                // Solo ejecutar en móvil
                if ($(window).width() > 991) return;
                
                // Animar hacia fuera
                $sidebar.css('transform', 'translateX(100%)');
                $overlay.css('opacity', '0');
                $("#close-mobile-filter").css('opacity', '0');
                
                // Después de la animación, resetear estilos
                setTimeout(function() {
                    $sidebar.css({
                        'position': '',
                        'top': '',
                        'right': '',
                        'width': '',
                        'max-width': '',
                        'height': '',
                        'background': '',
                        'z-index': '',
                        'overflow': '',
                        'padding': '',
                        'box-shadow': '',
                        'transform': '',
                        'transition': ''
                    });
                    
                    $overlay.hide().css({
                        'opacity': '',
                        'transition': ''
                    });
                    
                    $body.css('overflow', '');
                    
                    // Remover botón de cerrar
                    $("#close-mobile-filter").remove();
                }, 300); // Mismo tiempo que la transición
            }
            
            // Event listeners - SIEMPRE registrar estos
            $mobileFilterBtn.on('click', openMobileFilters);
            $overlay.on('click', closeMobileFilters);
            
            // Verificar tamaño inicial y al cambiar tamaño
            checkScreenSize();
            $(window).on('resize', function() {
                checkScreenSize();
            });
            
            // Actualizar badge inicialmente
            updateFilterBadge();
        }
    }
    
    // Inicializar filtros móviles
    mobileFilterActive();
    
    // Init function billed
    checkBilled();
})(jQuery);
// Check billed
function checkBilled() {
    var checkBox = $("#cb_billed_type");
    var forMonth = $(".for-month");
    var forYear = $(".for-year");
    for (var i = 0; i < forMonth.length; i++) {
        if (checkBox.is(":checked")) {
            forYear.eq(i).addClass("display-year");
            forMonth.eq(i).removeClass("display-month");
        } else {
            forYear.eq(i).removeClass("display-year");
            forMonth.eq(i).addClass("display-month");
        }
    }
}
//Perfect Scrollbar
const ps = new PerfectScrollbar(".mobile-header-wrapper-inner");

// Ocultar botón de filtros cuando se abre el menú hamburguesa
function handleSidebarAndFilterBtn() {
  var $sidebar = $('.mobile-header-active');
  var $filterBtn = $('#mobile-filter-btn');

  // Observar cambios de clase en la sidebar
  if ($sidebar.length && $filterBtn.length) {
    // Usar MutationObserver para detectar cambios de clase
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          if ($sidebar.hasClass('sidebar-visible')) {
            $filterBtn.hide();
          } else {
            $filterBtn.show();
          }
        }
      });
    });

    observer.observe($sidebar[0], { attributes: true });
  }
}

$(document).ready(function() {
  handleSidebarAndFilterBtn();
});
